import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput 
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';

const getVolume=(weight) => {

    let dummy= null;
    if(!weight || weight < 110 || weight > 400){
        dummy = (document.getElementById("tx_weight"))? document.getElementById("tx_weight").setAttribute("style", "color: red;"): null;
        return 0
    }else if(weight < 150){
        dummy = (document.getElementById("tx_weight"))?document.getElementById("tx_weight").removeAttribute("style"):null;
        return '690'
    }else if(weight < 175){
        dummy = (document.getElementById("tx_weight"))?document.getElementById("tx_weight").removeAttribute("style"):null;
        return '825'
    }else if(weight < 401){
        dummy = (document.getElementById("tx_weight"))?document.getElementById("tx_weight").removeAttribute("style"):null;
        return '880'
    }else {
        dummy = (document.getElementById("tx_weight"))? document.getElementById("tx_weight").setAttribute("style", "color: red;"): null;
        return null
    }
}


const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    return (
        <Fragment>
             <TableCell >
            <TextInput
                id="tx_weight"
                source="weight"
                label=""
                onChange={value => form.change('volume_collected', null)}
                {...rest}
            />
            </TableCell>
            <TableCell >
            <TextInput
                source="volume_collected"
                label=""
                value = {
                    getVolume(formData.weight),
                    formData.volume_collected = getVolume(formData.weight)
                }
                {...rest}
                
            />
            </TableCell>
        </Fragment>
    );
};
const WeightVolume = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default WeightVolume